import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import profile from '../asset/coverimg.png'; // 프로필 이미지 경로
import profile2 from '../asset/coverimg2.png'; // 프로필 이미지 경로
import "react-responsive-carousel/lib/styles/carousel.min.css"; // 스타일 임포트
import '../App.css';

const BannerSlider = ({ title, text, title2, text2, sectionName }) => {
  return (
    <>
      <h3 style={{ padding: '20px', textAlign: 'center' }}>{sectionName}</h3>
      <div className='carouselContainer'>
        <Carousel
          showArrows={false}
          showThumbs={false}
          showStatus={false}
          infiniteLoop={true}
          emulateTouch={false}
          autoPlay={false}
          interval={7000}
          transitionTime={700}
          swipeable={true}
          width={'100%'}
        >
          <div className="banner-slide">
            <div>
              <h2>{title}</h2>
              <img src={profile} alt="Profile" className="banner-image" />
              <h3>{text}</h3>
            </div>
          </div>
          <div className="banner-slide">
            <h2>{title2}</h2>
            <img src={profile2} alt="Profile" className="banner-image" />
            <h3>{text2}</h3>
          </div>
        </Carousel>
      </div>
    </>
  );
}

export default BannerSlider;
